import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import appData from './appData'
import settings from './settings'
import library from './library'
import automationTest from './automationTest'
import { AIAddOnGetters } from 'bh-mod'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		user,
		settings,
		appData,
		library,
		automationTest,
	},
	state: {
		loading: false,
		instances: [],
		instance: null,
		hives: [],
		cats: [],
		theApp: {},
		featureStates: {},
		globalSearch: '',
		sidebarSelection: "Agents",
		fileStructure: [],
		uploadDialog: false,
		showKnowledgeBaseModal: false,
		confirmAccess: {
			show: false,
			token: "",
			validUntil: null,
		},
	},
	mutations: {
		validateConfirmAccess(state) {
			if (!state.confirmAccess.token || state.confirmAccess.validUntil < Date.now()) {
				state.confirmAccess.token = "";
				state.confirmAccess.validUntil = null;
				state.confirmAccess.show = true;
			}
		},
		setConfirmAccess(state, { token, validUntil }) {
			state.confirmAccess.token = token;
			state.confirmAccess.validUntil = validUntil;
			state.confirmAccess.show = false;

			const timer = validUntil - Date.now();

			if (timer > 0) {
				setTimeout(() => {
					state.confirmAccess.token = "";
					state.confirmAccess.validUntil = null;
					state.confirmAccess.show = true;
				}, timer);
			} else {
				state.confirmAccess.token = "";
				state.confirmAccess.validUntil = null;
				state.confirmAccess.show = true;
			}
		},
		clearConfirmAccess(state) {
			state.confirmAccess.token = "";
			state.confirmAccess.validUntil = null;
			state.confirmAccess.show = false;
		},
		SET_KNOWLEDGE_BASE_MODAL(state, value) {
			state.showKnowledgeBaseModal = value;
		},
		SET_FILE_STRUCTURE(state, data) {
			state.fileStructure = data;
		},
		SET_APP(state, data) {
			state.theApp = data;
		},
		SET_FEATURE_STATES(state, data) {
			state.featureStates = data;
		},
		SET_INSTANCE: (state, data) => {
			state.instance = data;
			state.cats = data.activeApps;
		},
		SIDEBAR_SELECTION(state, data) {
			state.sidebarSelection = data;
		},
		UPDATE_GLOBAL_SEARCH(state, data = '') {
			state.globalSearch = data;
		},
		LOAD: (state, bool = !state.loading) => state.loading = bool,
		cancelUpload: (state) => {
			state.uploadDialog = false
		},
		uploadDialog: (state, folders = []) => {
			state.uploadDialog = true
			state.folders = folders
		},
	},
	getters: {
		isCurrentUserOwner: (state) => {
			return state.instance.billingOwner?.id === state.user.user?.id || state.instance.owner?.id === state.user.user?.id;
		},

		isAPIAddOnEnabled: (state) => {
			const addons = state.instance?.selectedPackageExtras || [];
			const APIAddOn = addons.find((addon) => 
				addon.package_extra?.identifier === 'api_calls' || 
				addon.package_extra?.itemCode === 'AD-API'
			);
			return !!APIAddOn;
		},

		...AIAddOnGetters
	}
})
